import React, { useContext } from "react";
import { AppContext } from "../../../../context";
// import "./AHPWelcome.css";
import "../../../../assets/fonts/priva/privatwopro.otf";
// import ahpLogo from "../../../../assets/images/logo/ahp_logo_pos_800x200px.jpg";
import ahpLogo from "../../../../assets/images/logo/logo-white-2.png";

function AHPWelcome({ villageIndex, villagesList }) {
  const info = useContext(AppContext);

  const textStyle = {
    fontFamily: "'Open Sans','sans serif'",
    textTransform: "uppercase",
    display: "inline-block",
    padding: "5px 20px",
    fontWeight: 900,
    fontSize: "clamp(12px,3vw,32px)",
  };

  return (
    <div
      className="ahp-welcome-block"
      // style={{
      //   width: "100%",
      //   height: "100vh",
      // }}
    >
      <div
        style={{
          position: "absolute",
          top: "65vh",
          left: "4vw",
          color: "white",
        }}
      >
        <div
          style={{
            backgroundImage:
              "url('https://aldeiashistoricasdeportugal.com/wp-content/themes/aldeiashistportugal/img/home/slide-caption-bg.png')",
            position: "relative",
            backgroundRepeat: "no-repeat",
            backgroundSize: "clamp(200px,50vw,600px)",
            height: 400,
          }}
        >
          <div
            style={{
              position: "relative",
              top: "5vw",
              left: "10vw",
            }}
          >
            <div
              style={{
                ...textStyle,
                backgroundColor: "#9D8EAFCC",
              }}
            >
              {info.t("welcome")}
            </div>
            <br />
            <div
              style={{
                ...textStyle,
                backgroundColor: "#82B8BACC",
              }}
            >
              {info.t("toTheHistoricalVillages")}
            </div>
            <br />
            <div
              style={{
                ...textStyle,
                backgroundColor: "#C9C330CC",
              }}
            >
              {info.t("ofPortugal")}
            </div>
            <br />
            <div
              style={{
                ...textStyle,
                fontSize: "1.5rem",
                backgroundColor: "#F39777CC",
              }}
            >
              {villagesList[villageIndex]?.label}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default AHPWelcome;
